/* Review spotlight: drive snap arrows, pagination, and the in-place Read more
   control. Card order is fixed in the section HTML. Do not reorder the cards
   here. That would put one product beside itself and shift layout. No network calls. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function behavior() {
    return reduce.matches ? 'auto' : 'smooth';
  }

  function setNavOff(btn, off) {
    if (off) btn.setAttribute('aria-disabled', 'true');
    else btn.removeAttribute('aria-disabled');
  }

  function cardsOf(track) {
    return track.querySelectorAll('[data-jdgm-card]');
  }

  function activeIndex(track) {
    var cards = cardsOf(track);
    var edge = track.getBoundingClientRect().left;
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    var target = edge + pad;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var dist = Math.abs(cards[i].getBoundingClientRect().left - target);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function scrollToIndex(track, index) {
    var cards = cardsOf(track);
    var card = cards[index];
    if (!card) return;
    var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
    var delta = card.getBoundingClientRect().left - track.getBoundingClientRect().left - pad;
    track.scrollBy({ left: delta, behavior: behavior() });
  }

  function paintPager(root, track) {
    var cards = cardsOf(track);
    var count = cards.length;
    var index = count ? activeIndex(track) + 1 : 0;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var atTrackEnd = maxScroll > 2 && track.scrollLeft >= maxScroll - 2;
    var counterIndex = index;
    if (atTrackEnd && window.matchMedia('(min-width: 750px)').matches) counterIndex = count;
    var status = root.querySelector('[data-jdgm-status]');
    if (status) {
      var text = counterIndex + ' / ' + count;
      if (status.textContent !== text) status.textContent = text;
    }
    var max = track.scrollWidth - track.clientWidth - 2;
    var atStart = track.scrollLeft <= 2 || index <= 1;
    var atEnd = track.scrollLeft >= max || index >= count;
    root.querySelectorAll('[data-jdgm-prev]').forEach(function (btn) {
      setNavOff(btn, atStart);
    });
    root.querySelectorAll('[data-jdgm-next]').forEach(function (btn) {
      setNavOff(btn, atEnd);
    });
  }

  function bodyOverflows(body) {
    var probe = body.cloneNode(true);
    probe.className = body.className + ' is-expanded';
    probe.setAttribute('aria-hidden', 'true');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.width = body.getBoundingClientRect().width + 'px';
    probe.style.height = 'auto';
    probe.style.maxHeight = 'none';
    body.insertAdjacentElement('afterend', probe);
    var over = probe.scrollHeight > body.clientHeight + 1;
    probe.remove();
    return over;
  }

  function syncMoreLabels(btn) {
    var open = btn.getAttribute('aria-expanded') === 'true';
    var more = btn.querySelector('[data-jdgm-more-label]');
    var less = btn.querySelector('[data-jdgm-less-label]');
    if (more) more.setAttribute('aria-hidden', open ? 'true' : 'false');
    if (less) less.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function bindReadMore(root) {
    root.querySelectorAll('[data-jdgm-body]').forEach(function (body) {
      var btn = body.parentElement && body.parentElement.querySelector('[data-jdgm-more]');
      if (!btn) return;
      if (btn.dataset.jdgmMore !== '1') {
        btn.dataset.jdgmMore = '1';
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          var nextOpen = !open;
          btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
          body.classList.toggle('is-expanded', nextOpen);
          syncMoreLabels(btn);
        });
      }
      syncMoreLabels(btn);
      if (btn.getAttribute('aria-expanded') === 'true') {
        btn.classList.add('is-shown');
        return;
      }
      btn.classList.toggle('is-shown', bodyOverflows(body));
    });
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = [];
    if (root.matches && root.matches('[data-jdgm-testimonials]')) nodes = [root];
    else nodes = root.querySelectorAll('[data-jdgm-testimonials]');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.dataset.jdgmBound === '1') return;
      var track = el.querySelector('[data-jdgm-track]');
      if (!track) return;
      el.dataset.jdgmBound = '1';
      bindReadMore(el);
      el.querySelectorAll('[data-jdgm-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          scrollToIndex(track, Math.max(0, activeIndex(track) - 1));
        });
      });
      el.querySelectorAll('[data-jdgm-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          var count = cardsOf(track).length;
          scrollToIndex(track, Math.min(count - 1, activeIndex(track) + 1));
        });
      });
      var queued = false;
      function sync() {
        queued = false;
        paintPager(el, track);
      }
      track.addEventListener('scroll', function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(sync);
      }, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { bindReadMore(el); });
      }
      sync();
    });
  }

  if (!window.__jdgmTestimonials) {
    window.__jdgmTestimonials = true;
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-jdgm-testimonials]').forEach(function (el) {
        var track = el.querySelector('[data-jdgm-track]');
        if (!track || el.dataset.jdgmBound !== '1') return;
        bindReadMore(el);
        paintPager(el, track);
      });
    }, { passive: true });
    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.matches && target.matches('[data-jdgm-testimonials]')) {
        delete target.dataset.jdgmBound;
      }
      target.querySelectorAll && target.querySelectorAll('[data-jdgm-testimonials]').forEach(function (el) {
        delete el.dataset.jdgmBound;
      });
      boot(target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
})();
